export default __webpack_public_path__ + "static/media/DefaultBuilding.56393ac3.svg";